import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getPageData } from 'utils/lib/strapi';

const useShowAmountRaisedList = () => {
  const queryClient = useQueryClient();
  const strapiContentId = queryClient.getQueryData(['strapiContentId']);
  const { data, isError, isSuccess, isLoading } = useQuery({
    queryKey: ['showAmountRaisedList', strapiContentId],
    queryFn: () =>
      getPageData({
        type: 'offering-show-amount-settings-collection',
        preview: Boolean(strapiContentId),
        id: strapiContentId,
      }),
    refetchOnMount: true,
  });

  const parsedData = data?.attributes?.showAmountRaisedOfferingSlug?.map((item) => item?.value);
  const truthySuccess = isSuccess && data !== undefined;
  return {
    data: parsedData || [],
    isError,
    isLoading,
    isSuccess: truthySuccess,
  };
};

export default useShowAmountRaisedList;
